import { Component } from '@angular/core';
import { CaiRoutesService } from '../../routes/cai-routes.service';

@Component({
  selector: 'cai-project-edit-icon',
  template: `@if (projectId) {
    <div>
      <a
        class="btn shadow-none bubble-btn"
        [routerLink]="['/projects', projectId, 'versions', projectVersionId, 'edit', 'general']"
        [queryParams]="{ source: 'designer' }"
        [ngbTooltip]="'Project::ProjectSettings' | abpLocalization"
        *abpPermission="'Designer.Projects.Edit'"
      >
        <i class="fa-solid fa-gear fa-lg"></i>
      </a>
    </div>
  }`,
  standalone: false,
})
export class ProjectEditIconComponent {
  projectId: string;
  projectVersionId: string;

  constructor(public caiRoutesService: CaiRoutesService) {
    this.caiRoutesService.freshProjectData$.subscribe((projectData) => {
      this.projectId = projectData.projectId;
      this.projectVersionId = projectData.projectVersionId;
    });
  }
}
